<script>
/**
 * ****************************************************************************
 * @description     :   CompanyName
 * @created at      :   2022/07/28
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   STworks
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
/**
 * Import libraries
 */
import { mapState } from 'vuex';

/**
 * import template
 */
import template from './template.html';

import ChangeCompany from '@/views/popup/changeCompany';

/**
 * Define main layout
 */
const CompanyName = {
    name: 'CompanyName',
    template: template,
    components: {
        ChangeCompany
    },
    data() {
        return {
            showModal: false
        };
    },
    computed: {
        ...mapState('app', ['user']),
        companyName() {
            if (
                this.user.switchUser &&
                this.user.switchUser.契約会社名 &&
                this.user.switchUser.契約会社名 != this.user.契約会社名
            ) {
                return this.user.switchUser.契約会社名;
            }
            return this.user.契約会社名;
        }
    },
    methods: {}
};
export default CompanyName;
</script>
